"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpdatedApprovedListWithoutQueryingContract = exports.clientConnectedToCatalystIn = void 0;

var dcl_catalyst_commons_1 = require("dcl-catalyst-commons");

var CatalystClient_1 = require("../CatalystClient");

var CatalystsList_1 = __importDefault(require("../CatalystsList"));
/**
 * Returns a CatalystClient connected to one of the catalysts in the given network
 */


function clientConnectedToCatalystIn(_x, _x2) {
  return _clientConnectedToCatalystIn.apply(this, arguments);
}

function _clientConnectedToCatalystIn() {
  _clientConnectedToCatalystIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(network, origin) {
    var noContractList, list, shuffled, _iterator3, _step3, catalystUrl, client, isUp;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getUpdatedApprovedListWithoutQueryingContract({
              preKnownServers: {
                network: network
              },
              origin: origin
            });

          case 2:
            noContractList = _context.sent;

            if (!noContractList) {
              _context.next = 7;
              break;
            }

            list = noContractList;
            _context.next = 11;
            break;

          case 7:
            console.warn('Falling back to the smart contract to get an updated list of active servers');
            _context.next = 10;
            return getApprovedListFromContract(network);

          case 10:
            list = _context.sent;

          case 11:
            shuffled = shuffleArray(list);
            _iterator3 = _createForOfIteratorHelper(shuffled);
            _context.prev = 13;

            _iterator3.s();

          case 15:
            if ((_step3 = _iterator3.n()).done) {
              _context.next = 25;
              break;
            }

            catalystUrl = _step3.value;
            client = new CatalystClient_1.CatalystClient(catalystUrl, origin);
            _context.next = 20;
            return isServerUp(client);

          case 20:
            isUp = _context.sent;

            if (!isUp) {
              _context.next = 23;
              break;
            }

            return _context.abrupt("return", client);

          case 23:
            _context.next = 15;
            break;

          case 25:
            _context.next = 30;
            break;

          case 27:
            _context.prev = 27;
            _context.t0 = _context["catch"](13);

            _iterator3.e(_context.t0);

          case 30:
            _context.prev = 30;

            _iterator3.f();

            return _context.finish(30);

          case 33:
            throw new Error("Couldn't find a server on the ".concat(network, " network that was up"));

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[13, 27, 30, 33]]);
  }));
  return _clientConnectedToCatalystIn.apply(this, arguments);
}

exports.clientConnectedToCatalystIn = clientConnectedToCatalystIn;

function isServerUp(_x3) {
  return _isServerUp.apply(this, arguments);
}

function _isServerUp() {
  _isServerUp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(client) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return Promise.all([client.fetchContentStatus(), client.fetchLambdasStatus()]);

          case 3:
            return _context2.abrupt("return", true);

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", false);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 6]]);
  }));
  return _isServerUp.apply(this, arguments);
}

function getApprovedListFromContract(_x4) {
  return _getApprovedListFromContract.apply(this, arguments);
}
/**
 * The idea here is to build an updated list of the catalysts approved by the DAO, without actually querying the DAO's contract
 * directly. This is because that query is both slow and expensive, so the idea is to use a list of known servers and ask them
 * for the updated list. The thing is this known server list might be outdated, so we need to take that into account. We will
 * take N (defined by REQUIRED_LISTS below) random servers from this known list, and ask them for the currently approved ones. We will then use the intersection of those
 * N lists as the updated list.
 */


function _getApprovedListFromContract() {
  _getApprovedListFromContract = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(network) {
    var servers;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(network === 'mainnet')) {
              _context3.next = 6;
              break;
            }

            _context3.next = 3;
            return dcl_catalyst_commons_1.getMainnetCatalysts();

          case 3:
            _context3.t0 = _context3.sent;
            _context3.next = 9;
            break;

          case 6:
            _context3.next = 8;
            return dcl_catalyst_commons_1.getRopstenCatalysts();

          case 8:
            _context3.t0 = _context3.sent;

          case 9:
            servers = _context3.t0;
            return _context3.abrupt("return", servers.map(function (_ref7) {
              var address = _ref7.address;
              return address;
            }));

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getApprovedListFromContract.apply(this, arguments);
}

var REQUIRED_LISTS = 3;

function getUpdatedApprovedListWithoutQueryingContract(_x5) {
  return _getUpdatedApprovedListWithoutQueryingContract.apply(this, arguments);
}

function _getUpdatedApprovedListWithoutQueryingContract() {
  _getUpdatedApprovedListWithoutQueryingContract = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref) {
    var preKnownServers, origin, requiredLists, fetchApprovedCatalysts, catalystListFetch, requiredAmountOfLists, knownServers, shuffledPreKnownServers, approvedServersList, allLists, i, list, intersection;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            preKnownServers = _ref.preKnownServers, origin = _ref.origin, requiredLists = _ref.requiredLists, fetchApprovedCatalysts = _ref.fetchApprovedCatalysts;
            // Set defaults if needed
            catalystListFetch = fetchApprovedCatalysts !== null && fetchApprovedCatalysts !== void 0 ? fetchApprovedCatalysts : function (catalystUrl, origin) {
              return fetchCatalystsApprovedByDAO(catalystUrl, origin);
            };
            requiredAmountOfLists = requiredLists !== null && requiredLists !== void 0 ? requiredLists : REQUIRED_LISTS; // Get the list of known servers

            knownServers = 'list' in preKnownServers ? preKnownServers.list : CatalystsList_1.default[preKnownServers.network]; // If I don't know enough servers, then it doesn't make sense to continue

            if (!(knownServers.length < requiredAmountOfLists)) {
              _context4.next = 6;
              break;
            }

            return _context4.abrupt("return", undefined);

          case 6:
            // Shuffle the list
            shuffledPreKnownServers = shuffleArray(knownServers); // Ask N of them for their list

            _context4.next = 9;
            return Promise.all(shuffledPreKnownServers.slice(0, requiredAmountOfLists + 3).map(function (server) {
              return server.address;
            }).map(function (address) {
              return catalystListFetch(address, origin);
            }));

          case 9:
            approvedServersList = _context4.sent;
            // Removed any failures
            allLists = approvedServersList.filter(function (approvedServerList) {
              return !!approvedServerList;
            }); // Check if we need to ask for anyone else's list

            i = requiredAmountOfLists + 3;

          case 12:
            if (!(i < shuffledPreKnownServers.length && allLists.length < requiredAmountOfLists)) {
              _context4.next = 20;
              break;
            }

            _context4.next = 15;
            return catalystListFetch(shuffledPreKnownServers[i].address, origin);

          case 15:
            list = _context4.sent;

            if (list) {
              allLists.push(list);
            }

            i++;
            _context4.next = 12;
            break;

          case 20:
            if (!(allLists.length < requiredAmountOfLists)) {
              _context4.next = 22;
              break;
            }

            return _context4.abrupt("return", undefined);

          case 22:
            // Calculate the intersection
            intersection = calculateIntersection(allLists);
            return _context4.abrupt("return", intersection.length > 0 ? intersection : undefined);

          case 24:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getUpdatedApprovedListWithoutQueryingContract.apply(this, arguments);
}

exports.getUpdatedApprovedListWithoutQueryingContract = getUpdatedApprovedListWithoutQueryingContract;

function calculateIntersection(lists) {
  var _a;

  var count = new Map();

  var _iterator = _createForOfIteratorHelper(lists),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var list = _step.value;

      var _iterator2 = _createForOfIteratorHelper(list),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var element = _step2.value;
          count.set(element, ((_a = count.get(element)) !== null && _a !== void 0 ? _a : 0) + 1);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return Array.from(count.entries()).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        _ = _ref3[0],
        count = _ref3[1];

    return count === lists.length;
  }).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 1),
        element = _ref5[0];

    return element;
  });
}

function fetchCatalystsApprovedByDAO(_x6, _x7) {
  return _fetchCatalystsApprovedByDAO.apply(this, arguments);
}

function _fetchCatalystsApprovedByDAO() {
  _fetchCatalystsApprovedByDAO = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(catalystUrl, origin) {
    var client, servers;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            client = new CatalystClient_1.CatalystClient(catalystUrl, origin);
            _context5.prev = 1;
            _context5.next = 4;
            return client.fetchCatalystsApprovedByDAO({
              timeout: '10s'
            });

          case 4:
            servers = _context5.sent;
            return _context5.abrupt("return", servers.map(function (_ref8) {
              var address = _ref8.address;
              return address;
            }));

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", undefined);

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 8]]);
  }));
  return _fetchCatalystsApprovedByDAO.apply(this, arguments);
}

function shuffleArray(arr) {
  for (var i = arr.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var _ref6 = [arr[j], arr[i]];
    arr[i] = _ref6[0];
    arr[j] = _ref6[1];
  }

  return arr;
}